import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminPrimavera() {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(null);
    const [err, setErr] = useState(null);
    const [filter, setFilter] = useState("");

    const reload = () => {
        api.get("/admin/primavera").then((r) => setData(r.data)).catch((e) => setErr(e.message));
    };
    useEffect(reload, []);

    const buildAll = async () => {
        if (!window.confirm("Ricostruisce l'elenco Primavera di TUTTE le 56 squadre.\n\n• Reset status PRIM esistenti\n• Ricalcola Ugly+GK fuori quota+5 under-23\n\nProcedere?")) return;
        setBusy("build-all");
        setErr(null);
        try {
            await api.post("/admin/primavera/build-all");
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    const buildOne = async (teamId) => {
        setBusy(`build-${teamId}`);
        setErr(null);
        try {
            const r = await api.post(`/admin/primavera/build/${teamId}`);
            reload();
            window.alert(`PRIM ricostruita: ${r.data.total} giocatori (${r.data.eligible ? "✓ ELIGIBLE" : "✗ NON ELIGIBLE (<13)"})`);
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    const toggleEnroll = async (teamId, enrolled) => {
        setBusy(`enroll-${teamId}`);
        setErr(null);
        try {
            await api.put(`/admin/primavera/${teamId}/enroll`, { enrolled: !enrolled });
            reload();
        } catch (e) {
            setErr(e.response?.data?.detail || e.message);
        } finally {
            setBusy(null);
        }
    };

    if (!data) return <div className="op-mono text-sm text-t8f95a3 animate-pulse">// CARICAMENTO…</div>;

    const teams = data.teams.filter((t) => !filter || t.team_name.toLowerCase().includes(filter.toLowerCase()));

    return (
        <div data-testid="admin-primavera-page">
            <div className="op-label" style={{ color: "rgb(var(--tc-7c3aed))" }}>// CAMPIONATO</div>
            <h2 className="op-heading text-3xl mt-2 mb-2">Primavera</h2>
            <p className="op-mono text-xs text-t8f95a3 mb-4 max-w-3xl leading-relaxed">
                La rosa Primavera è composta da: tutti gli <span className="text-te8ff00">Ugly con PESDB</span>,
                un <span className="text-t2bb6ff">portiere fuori quota</span> (VG più basso) solo se non c'è un GK negli Ugly,
                e fino a <span className="text-tff7a1a">5 giocatori della prima squadra</span> con età ≤ 23 (VG più basso, tie-break stipendio).
                Servono <strong className="text-tffffff">≥ 13 giocatori PRIM</strong> per iscriversi al campionato.
            </p>

            <div className="op-card p-4 mb-4 flex flex-wrap items-center justify-between gap-3">
                <div className="flex gap-6">
                    <div>
                        <div className="op-label text-[10px]">ELIGIBLE</div>
                        <div className="op-heading text-2xl text-t2bb6ff" data-testid="kpi-eligible">
                            {data.total_eligible} <span className="text-t8f95a3 text-sm">/ {data.teams.length}</span>
                        </div>
                    </div>
                    <div>
                        <div className="op-label text-[10px]">ISCRITTE</div>
                        <div className="op-heading text-2xl text-t7c3aed" data-testid="kpi-enrolled">
                            {data.total_enrolled} <span className="text-t8f95a3 text-sm">/ {data.teams.length}</span>
                        </div>
                    </div>
                </div>
                <button
                    onClick={buildAll}
                    disabled={busy === "build-all"}
                    className="op-btn op-btn-primary px-5 py-2 disabled:opacity-50"
                    data-testid="build-all-btn"
                >
                    {busy === "build-all" ? "Ricostruzione…" : "↻ Ricostruisci tutte"}
                </button>
            </div>

            {err && <div className="border border-tff3b30 bg-tff3b30/10 text-tff3b30 text-xs p-2 mb-3">{err}</div>}

            <input
                placeholder="Cerca squadra…"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="op-input w-full sm:w-80 mb-3"
                data-testid="filter-input"
            />

            <div className="op-card overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="text-[10px] uppercase tracking-wider text-t8f95a3 border-b border-t22252a">
                        <tr>
                            <th className="py-2 px-3 text-left">Squadra</th>
                            <th className="py-2 px-3 text-center">PRIM</th>
                            <th className="py-2 px-3 text-center">Eligible</th>
                            <th className="py-2 px-3 text-center">Iscritta</th>
                            <th className="py-2 px-3 text-right">Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teams.map((t) => (
                            <tr key={t.team_id} className="border-b border-t1a1d24 hover:bg-t0f1115">
                                <td className="py-2 px-3 text-tffffff">{t.team_name}</td>
                                <td className="py-2 px-3 text-center op-mono">
                                    <span style={{ color: t.eligible ? "rgb(var(--tc-2bb6ff))" : "rgb(var(--tc-ff3b30))" }}>{t.prim_count}</span>
                                </td>
                                <td className="py-2 px-3 text-center">
                                    {t.eligible ? (
                                        <span className="op-mono text-[10px] text-t2bb6ff">✓ SI</span>
                                    ) : (
                                        <span className="op-mono text-[10px] text-t5c6370">— no</span>
                                    )}
                                </td>
                                <td className="py-2 px-3 text-center">
                                    {t.enrolled ? (
                                        <span className="op-mono text-[10px] px-2 py-0.5 border border-t7c3aed text-t7c3aed">ISCRITTA</span>
                                    ) : (
                                        <span className="op-mono text-[10px] text-t5c6370">—</span>
                                    )}
                                </td>
                                <td className="py-2 px-3 text-right">
                                    <div className="flex justify-end gap-1">
                                        <button
                                            onClick={() => buildOne(t.team_id)}
                                            disabled={busy === `build-${t.team_id}`}
                                            className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border border-t22252a hover:border-t2bb6ff text-t2bb6ff"
                                            title="Ricostruisci PRIM per questa squadra"
                                            data-testid={`build-${t.team_id}`}
                                        >
                                            ↻
                                        </button>
                                        <button
                                            onClick={() => toggleEnroll(t.team_id, t.enrolled)}
                                            disabled={busy === `enroll-${t.team_id}` || (!t.enrolled && !t.eligible)}
                                            className="op-mono text-[10px] uppercase tracking-wider px-2 py-1 border transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                                            style={{
                                                borderColor: t.enrolled ? "rgb(var(--tc-ff3b30))" : "rgb(var(--tc-7c3aed))",
                                                color: t.enrolled ? "rgb(var(--tc-ff3b30))" : "rgb(var(--tc-7c3aed))",
                                            }}
                                            title={!t.eligible && !t.enrolled ? "Non eligible (servono ≥13 PRIM)" : ""}
                                            data-testid={`enroll-${t.team_id}`}
                                        >
                                            {busy === `enroll-${t.team_id}` ? "..." : (t.enrolled ? "Ritira" : "Iscrivi")}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
